import { render, staticRenderFns } from "./verificationerror.vue?vue&type=template&id=735de04a"
import script from "./verificationerror.vue?vue&type=script&lang=js"
export * from "./verificationerror.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports